import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from "rxjs";
import { TermsGiveoneComponent } from './components/terms-giveone/terms-giveone.component';
import { AlertasComponent } from '../alertas/alertas.component';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-giveone',
  templateUrl: './giveone.component.html',
  styleUrls: ['./giveone.component.sass']
})
export class GiveoneComponent implements OnInit {
  public subscriberReciever = "";
  public showErrorCelNum = false;
  public showErrorCelNumInvalido = false;
  public acceptTerms = false;
  public status;
  public amount = 9.99;
  public banRecieve = "";
  public transactionId = "";
  public paymentId = "";
  public subscriberRecieverName = "";
  public balanceAccount;
  public giftSendMessage = '';
  public paymentType = "1";
  public fullName;

  public tabActive = 'Compras';
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public token: string;
  loadObserver: Subscription;
  giftReceived: Subscription;
  public paymentData;
  public paymentscreen = 0;
  public index = 0;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, private router: Router, public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, public global: GlobalService, public dialog: MatDialog) {
    this.AngularFireAnalytics.setCurrentScreen("Regala 1 GB a un Pospago");
    this.AngularFireAnalytics.logEvent("Regala 1 GB a un Pospago-Screenview");
  }

  ngOnInit() {
    if (this.global.sessionReview() == true) {
      this.token= sessionStorage.getItem("token");
      this.balanceAccount = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.loadingScreenService.stopLoading();
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value)
      });
      this.giftReceived = this.global.paymentReceived.subscribe((value: boolean) => {
        if (value == true && this.index == 0) {
          const dialogConfig2 = new MatDialogConfig();
          dialogConfig2.disableClose = true;
          dialogConfig2.autoFocus = true;
          dialogConfig2.data = { message: "Se ha agregado el Regalo de 1GB" };
          const dialogRef2 = this.dialog.open(AlertasComponent, dialogConfig2);
          dialogRef2.afterClosed().subscribe(value2 => {
            if (value2 == "continue") {
              this.initializeData();
            }
          });

        }
      });
      this.fullName = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.firstNameField + ' ' + JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastNameField;
    }
  }
  refreshDataTo() {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw) {
  }
  validaciones() {
    var sw = true;
    if (this.subscriberReciever == "") {
      this.showErrorCelNum = true;
      sw = false;
    }
    else {
      this.showErrorCelNum = false;
      if (this.subscriberReciever.length > 0 && this.subscriberReciever.length < 10) {
        this.showErrorCelNumInvalido = true;
        sw = false;
      }
      else {
        this.showErrorCelNumInvalido = false;
      }
    }
    return sw;
  }
  activateTerms() {
    this.global.validateSession();
    if (this.acceptTerms) {
      this.acceptTerms = false;
    }
    else {
      this.acceptTerms = true;
    }
  }
  notif2() {
    let getAccount = JSON.parse(atob(sessionStorage.getItem("getAccountDetails")));
    let account = sessionStorage.getItem("selectBan");
    let subscriber = this.global.getSuscriberByDefault(atob(account));
    this.global.suspendedAccount("S", atob(account), btoa(subscriber), getAccount.AccounInfo.billBalanceField);

  }
  notifPayment1GB(banRecieve) {
    let typeMessage = 'dataPackage';
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: "Estimado cliente este cargo que desea realizar no califica para cargo en factura, por favor continúe su compra efectuando el pago inmediato usando su tarjeta de crédito.", btmConfirm: true, labelSi: 'Pagar', labelNo: 'Cancelar' };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == 'continue') {
        this.global.newPaymentNoLimit(3, typeMessage, this.selectBan, JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField, this.amount, atob(sessionStorage.getItem("email")), sessionStorage.getItem("name"), "REG1GB", this.token, banRecieve, this.subscriberReciever);
      }
    });
  }
  addGift() {
    if (this.global.validateSession() === true) {
      if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.banStatusField === 'S' || JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.banStatusField === 's') {
        this.notif2();
      }
      else {
        for (var i = 0; i < JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.length; i++) {

          if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[i].subscriberNumberField == this.subscriberReciever) {
            this.global.notif("Este suscriptor no es valido para el regalo.");
            return false;
          }
        }

        if (this.validaciones()) {
          if (this.acceptTerms) {
            if (this.status == "S") {
              this.notif2();
            }
            else {
              this.loadingScreenService.startLoading();
              this.services.GetSubscriber(this.token, this.subscriberReciever).subscribe(data => {
                if (data.HasError == false) {
                  if (data.ErrorDesc != '' && data.ErrorDesc != null) {
                    this.global.notif(data.ErrorDesc);
                  }
                  this.banRecieve = data.Account;
                  this.subscriberRecieverName = data.AccountName;
                  //valido el credito "CR"
                  var balanceAccount = this.balanceAccount.replace(",", "");
                  if (this.balanceAccount.search("CR") > -1) {
                    balanceAccount = 0;
                  }
                  this.validateCreditLimit(this.banRecieve, balanceAccount, this.amount);
                }
                else {
                  this.loadingScreenService.stopLoading();
                  this.global.notif(data.ErrorDesc);
                }
              });

            }
          } else {
            this.global.notif("Debe aceptar los Términos y Condicciones.");
          }
        } else {
          if (this.showErrorCelNum) {
            this.global.notif("El número de teléfono es un campo requerido.");
            return false;
          }
          if (this.showErrorCelNumInvalido) {
            this.global.notif("Por favor introduzca un número de teléfono valido.");
            return false;
          }
        }

      }
    }
  }
  showterms() {
    if (this.global.validateSession() === true) {
      if (sessionStorage.getItem("session") != null) {
        this.global.validateSession();
      }
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      this.dialog.open(TermsGiveoneComponent, dialogConfig);
    }
  }
  addGift1GB() {
    this.services.AddGift1GB(this.token, this.selectBan, this.fullName, this.banRecieve, JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField, this.subscriberReciever, this.giftSendMessage, '', this.paymentType).subscribe(data => {
      if (data.HasError == false) {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
        this.transactionId = data.Gift1GBIDTransact;
        this.refreshDataTo();
        this.router.navigate(['home']);
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  validateCreditLimit(banRecieve, balanceAccount, amount) {
    this.loadingScreenService.startLoading();
    this.services.validateCreditLimit(this.selectBan, balanceAccount, this.amount).subscribe(data => {
      if (data.HasError == false) {

        var availableCredit = String(data.AvailableCredit);

        this.paymentId = data.paymentid;
        var remaining = parseFloat(availableCredit) - parseFloat(this.amount.toString());
        if (remaining > 0) {
          this.addGift1GB();
        }
        else {
          this.loadingScreenService.stopLoading();
          this.notifPayment1GB(banRecieve);


        }
        //
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });


  }
}
